import { render, staticRenderFns } from "./RejectTender.vue?vue&type=template&id=583ebdc4&scoped=true&"
import script from "./RejectTender.vue?vue&type=script&lang=js&"
export * from "./RejectTender.vue?vue&type=script&lang=js&"
import style0 from "./RejectTender.vue?vue&type=style&index=0&id=583ebdc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583ebdc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('583ebdc4')) {
      api.createRecord('583ebdc4', component.options)
    } else {
      api.reload('583ebdc4', component.options)
    }
    module.hot.accept("./RejectTender.vue?vue&type=template&id=583ebdc4&scoped=true&", function () {
      api.rerender('583ebdc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/RejectTender.vue"
export default component.exports